import { IGeoImageRepository } from '../../domain/repositories/IGeoImage.repository'
import { GeoImageClient } from './GeoImageClient.abstract'
import { GeoImage } from '../../domain/entities/GeoImage'
import { GeoImagesByTypeDto } from '../../domain/dtos/GeoImagesByType.dto'
import { CreateGeoImageSchema } from '../schemas/CreateGeoImage.schema'
import { GeoImageSchema } from '../schemas/GeoImage.schema'
import { GeoImagesByTypeSchema } from '../schemas/GeoImagesByType.schema'
import { UpdateGeoImageSchema } from '../schemas/UpdateGeoImage.schema'
import { HttpStatusCodeEnum } from '../../../@shared/domain/enums/HttpStatusCode.enum'

export class GeoImageRepositoryApiAdapter implements IGeoImageRepository {
	private readonly _endpoint = '/v2/ImagemParaProcessamento'

	constructor(private readonly _httpClient: GeoImageClient) {}

	async create(geoImage: GeoImage): Promise<void> {
		const input = CreateGeoImageSchema.parse(geoImage)

		const config = {
			headers: {
				'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001',
			},
		}

		const response = await this._httpClient.post(this._endpoint, input, config)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error('Não foi possível cadastrar imagem. Por favor, tente novamente')
		}

		return
	}

	async update(geoImage: GeoImage): Promise<void> {
		const input = UpdateGeoImageSchema.parse(geoImage)

		const config = {
			headers: {
				'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001',
			},
		}

		const response = await this._httpClient.put(this._endpoint, input, config)

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error('Não foi possível editar imagem. Por favor, tente novamente')
		}

		return
	}

	async delete(exclusionZoneIds: string[]): Promise<void> {
		const response = await this._httpClient.delete(this._endpoint, {
			params: { id: exclusionZoneIds },
			paramsSerializer: {
				indexes: null,
			},
		})

		if (response.status !== HttpStatusCodeEnum.Ok) {
			throw new Error('Não foi possível excluir imagem. Por favor, tente novamente')
		}

		return
	}

	async getAll(): Promise<GeoImage[]> {
		const response = await this._httpClient.get(`${this._endpoint}/recuperar-todas`)

		if (response.status !== HttpStatusCodeEnum.Ok) return []

		return GeoImageSchema.array().parse(response.data)
	}

	async getByMeasurementId(measurementId: string): Promise<GeoImagesByTypeDto> {
		const response = await this._httpClient.get(
			`${this._endpoint}/recuperar-para-dropdown-estrato-inventario-florestal-por-id-medicao/${measurementId}`,
		)

		if (response.status !== HttpStatusCodeEnum.Ok)
			return { drone: [], lidar: [], mdt: [], satelite: [] }

		return GeoImagesByTypeSchema.parse(response.data)
	}
}
